import { createSchemaSelectors } from 'ngrx-normalizr';

import { AwarenessQuiz, awarenessQuizSchema } from '../schemas/awareness-quiz.schema';

const awarenessQuizSchemaSelectors = createSchemaSelectors<AwarenessQuiz>(awarenessQuizSchema);

export const getAwarenessQuizzes = awarenessQuizSchemaSelectors.getEntities;
